import SettingsPermissionsPage from './settings-permissions.page';

export default SettingsPermissionsPage;
